import { CurriculumRow } from '../CurriculumRow';

interface CurriculumFooterProps {
  rows: any[];
}

export const CurriculumFooter = ({ rows }: CurriculumFooterProps) => {
  return (
    <tfoot>
      {rows.map((row: any) => {
        return <CurriculumRow key={row.id} Tag="td" row={row} />;
      })}
    </tfoot>
  );
};
